// extracted by mini-css-extract-plugin
export default {"formField":"jpa-z","error":"kpa-z","disabled":"lpa-z","fieldError":"mpa-z","errorText":"npa-z","button":"opa-z","acknowledgment":"ppa-z"};